import { Box, IconButton, InputAdornment } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FormOnlyReason,
  ReminderCount,
  Unprocessed,
  YesOrNoFlug,
} from "../../../assets/data/Constants";
import TkButton from "../../../components/atoms/TkButton";
import TkDialog from "../../../components/atoms/TkDialog";
import TkLabelText from "../../../components/atoms/TkLabelText";
import TkSelectForm from "../../../components/atoms/TkSelectForm";
import TkCorporateSearchModal from "../../../components/molecules/TkCorporateSearchModal";
import { GlobalContext } from "../../../context/globalContext";
import { ITkDialogProps } from "../../../type/componentsType/TkDialog";
import { TkGetCodeList } from "../../../utils/TkGetCode";
import { httpAPI_CON001 } from "../api/request";
import TkPropertyMessageGet from "../../../utils/TkPropertyMessageGet";
import TkPrefecturesPick from "../../../components/molecules/TkPrefecturesPick";
import { ClearIcon } from "@mui/x-date-pickers";

interface SearchFieldProps {
  managerList?: any;
  onSearch: any;
  defaultValue: any;
}

/**
 * 検索エリア
 * @returns SearchField
 */
const SearchField: React.FC<SearchFieldProps> = (props) => {
  const { managerList = [], onSearch, defaultValue } = props;
  const [formValue, setFormValue] = useState({});

  const handleSearch = () => {
    onSearch && onSearch(formValue);
  };

  const handleChange = (field: any) => (value: any) => {
    let setValue: any = {};
    if (field !== "contractorNo") {
      let newValue =
        field === "prefectureList"
          ? value.map((i: any) => ({ prefecture: i }))
          : value;
      setValue = { ...formValue, [field]: newValue };
    } else {
      setValue = { ...formValue, ...value };
    }
    if (!value) delete setValue[field];

    setFormValue(setValue);
  };

  return (
    <Box className="SCRW110003SearchFormField">
      <Box className="searchItems">
        <TkSelectForm
          label="申請・届出（手続き）"
          selectPropsList={TkGetCodeList(Unprocessed)}
          onGetValue={handleChange("businessType")}
          wantToSetValue={defaultValue?.businessType}
          minW="180px"
        />
        <TkSelectForm
          label="督促回数"
          selectPropsList={TkGetCodeList(ReminderCount)}
          onGetValue={handleChange("reminderCount")}
          wantToSetValue={defaultValue?.reminderCount}
        />
        <TkSelectForm
          label="担当者"
          selectPropsList={managerList}
          onGetValue={handleChange("manager")}
          wantToSetValue={defaultValue?.manager}
        />
        <TkSelectForm
          label="システム利用・未利用法人"
          selectPropsList={TkGetCodeList(YesOrNoFlug)}
          onGetValue={handleChange("systemUsage")}
          wantToSetValue={defaultValue?.systemUsage}
          minW="230px"
        />
      </Box>
      <Box className="searchItems">
        <TkPrefecturesPick
          onSuccessful={handleChange("prefectureList")}
          wantToSetValue={defaultValue?.prefectureList?.map(
            (i: any) => i.prefecture
          )}
        />
        <CorporateSearch
          onChange={handleChange("contractorNo")}
          defaultValue={defaultValue}
        />
        <TkButton onClick={handleSearch}>検索</TkButton>
      </Box>
    </Box>
  );
};

/**
 * 法人検索部品
 * @param {any} props.onChange 値変更時のイベント
 * @param {any} props.defaultValue 初期値
 * @return CorprateSearch
 */
const CorporateSearch: React.FC<any> = (props) => {
  const { onChange, defaultValue } = props;

  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const [open, setOpen] = useState(false);
  const [corpList, setCorpList] = useState<any>([]);
  const [selectedItem, setSelectedItem] = useState<any>("");

  useEffect(() => {
    if (defaultValue?.contractorNo) {
      setSelectedItem(
        `${defaultValue?.contractorNo}:${defaultValue?.contractorName}`
      );
      onChange &&
        onChange({
          contractorNo: defaultValue?.contractorNo,
          contractorName: defaultValue?.contractorName,
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  const serchDialogOpen = () => {
    setCorpList([]);
    setOpen(true);
  };

  const handleCallApi = async (value?: any) => {
    // 契約者一覧参照API呼び出し
    try {
      const res = await httpAPI_CON001(value);

      if (res.resultCd === "I0000") {
        setCorpList(res.contractorList);
        setOpen(true);

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 選択
  const handleSave = (e: any) => {
    if (!e) return;

    setSelectedItem(`${e.contractorNo}:${e.corpName}`);

    onChange &&
      onChange({ contractorNo: e.contractorNo, contractorName: e.corpName });
    setOpen(false);
  };

  const handleClear = () => {
    setSelectedItem("");
    onChange && onChange("");
  };

  return (
    <Box className="SCRW110003Components" data-testid="corporateSearch">
      <Box className="corpSearch">
        <TkLabelText
          variant="standard"
          wantToSetValue={selectedItem}
          disabled
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={handleClear}
                  edge="end"
                  sx={{ padding: 0.5, marginRight: 0.2 }}
                >
                  <ClearIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <TkButton onClick={serchDialogOpen}>法人検索</TkButton>
      </Box>

      <TkCorporateSearchModal
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSave}
        onChangeSearchData={handleCallApi}
        listData={corpList}
      />
    </Box>
  );
};
interface TkSelectFormDialogProps extends ITkDialogProps {
  open?: boolean;
  title?: string;
  contextText?: string;
  okText?: string;
  cancelText?: string;
  onClose?: () => void;
  onOky?: any;
  onCancel?: () => void;
  children?: React.ReactNode;
  setFormOnlyReason?: any;
  label?: string;
  wantToSetValue?: any;
}

/**
 * TkSelectFormDialog部品は、プルダウン選択ダイアログを表示するための部品です。
 * @param open ダイアログの表示状態
 * @param onClose ダイアログの外側をクリックしたときのハンドラー関数
 * @param onCancel キャンセルボタンをクリックしたときのハンドラー関数
 * @param onOky OKボタンをクリックしたときのハンドラー関数
 * @param title ダイアログのタイトル
 * @param contextText ダイアログの説明文
 * @param cancelText キャンセルボタンのテキスト
 * @param okText OKボタンのテキスト
 * @param setFormOnlyReason 値をセットするためのハンドラー関数
 * @param label プルダウン選択のラベル
 * @param wantToSetValue プルダウン選択の初期値
 * @returns TkSelectFormDialogコンポーネント
 */
const TkSelectFormDialog: React.FC<TkSelectFormDialogProps> = (props) => {
  const {
    open = false,
    onClose,
    onCancel,
    onOky,
    children,
    title,
    contextText,
    cancelText,
    okText,
    setFormOnlyReason,
    label,
    wantToSetValue,
    ...rest
  } = props;

  const [value, setValue] = React.useState<any>();
  const [errorMsg, setErrorMsg] = React.useState("");

  const selectPropsList = TkGetCodeList(FormOnlyReason);

  /**
   * 原因選択が変更された時のハンドラー関数です。
   * @param value 選択された原因
   */
  const handleOnChange = (value: any) => {
    if (value.target.value === "") {
      setValue("");
    } else {
      setValue(value);
      setFormOnlyReason && setFormOnlyReason(value.target.value);
      setErrorMsg("");
    }
  };

  /**
   * OKボタンがクリックされた時のハンドラー関数です。
   */
  const handleOky = () => {
    if (value) {
      onOky && onOky(value);
      setErrorMsg("");
    } else {
      setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0044E"));
      return;
    }
  };

  return (
    <TkDialog
      {...rest}
      title={title}
      open={open}
      onClose={onClose}
      contextText={contextText}
      onSave={handleOky}
      onCancel={onCancel}
      cancelText={cancelText}
      okText={okText}
    >
      <TkSelectForm
        label={label}
        selectPropsList={selectPropsList || []}
        onChange={handleOnChange}
        wantToSetValue={wantToSetValue}
        fullWidth
        errorMessage={errorMsg}
      />
    </TkDialog>
  );
};

export { SearchField, CorporateSearch, TkSelectFormDialog };
